import { FooterComponentItem } from '@app-shared/components/footers/footer.model';
import { LatLngLiteral } from 'leaflet';

interface Logo {
  lightLogo: string;
  darkLogo: string;
  alt: string;
  width?: string;
  height?: string;
  mobileModeLightLogo?: string;
  mobileModeDarkLogo?: string;
  mobileModeWidth?: string;
  mobileModeHeight?: string;
  loginPageLogo?: string;
  loginPageWidth?: string;
  loginPageHeight?: string;
}

interface sideNavColor {
  lightBackgroundColor: string;
  lightColor: string;
  darkBackgroundColor: string;
  darkColor: string;
}

interface SsoStorageMapping {
  authenticated: string;
  accessToken: string;
}

export interface GeotabSsoStorageMapping {
  credentials: string;
  server: string;
}

export enum DefaultStorageType {
  LocalStorage = 'LocalStorage',
  SessionStorage = 'SessionStorage',
  Cookie = 'Cookie',
}

export enum DevicePrimaryKey {
  DeviceId = 'deviceId',
  SerialNumber = 'serialNumber',
}

export interface ClientConfig {
  clientName: string;
  logo: Logo;
  partnerLogo?: Logo;
  showLogo: boolean;
  showSurveyButton: boolean;
  showUserProfile: boolean;
  allowedRoutes: string[];
  authRoutes: string[];
  wildcardRoute: string;
  ssoLocalStorageKeys?: SsoStorageMapping | GeotabSsoStorageMapping;
  showCopyrightText?: boolean;
  showPrivacyPolicyLink?: boolean;
  showManageDriversTab: boolean;
  showChallengesTab: boolean;
  defaultMapCoordinates: LatLngLiteral;
  externalEventsLabel: string;
  showFeatureAnnouncement: boolean;
  showLogoutButton: boolean;
  defaultStorage: DefaultStorageType;
  devicePrimaryKey: DevicePrimaryKey;
  disableSuprsendNotification?: boolean;
  landingPageDetails?: {
    backgroundImage: {
      src: string;
    };
    brandImage?: {
      src: string;
    };
    headerImage: {
      src: string;
    };
    tagline?: string;
    footer?: FooterComponentItem;
    disableRegionSelection?: boolean;
    defaultUserCountry?: string;
    allowedRegions?: string[];
    headerColor?: string;
    largerFooter?: boolean;
    tagLineColor?: string;
  };
  showLandingPage: boolean;
  showPartnerLogo: boolean;
  showSecurityButton?: boolean;
  showHomePageAnnouncement?: boolean;
  showFeedbackButton?: boolean;
  sideNavColor?: sideNavColor;
  showUserTypeEmail?: boolean;
  showTheme?: boolean;
  showHeader?: boolean;
  showSideNav?: boolean;
  isAssetCentric?: boolean;
  showHelpLink?: boolean;
  helpDocumentationURL?: string;
  showCustomLoginPage?: boolean;
  allowedMobileRoutes?: string[];
  disableSentry?: boolean;
}

export const internalRoutes = ['trip-details', 'request-video', 'notification-setting'];
export const allowedRoutes = [
  'home',
  'safety-events',
  'trips',
  'live-view',
  'coaching',
  'video-requests',
  'drivers',
  'challenges',
  'reports',
  'assets',
  'user-management',
  'configurations',
];

export const ssoBlockedRoutes = ['user-management'];

export const DEFAULT_CLIENT_CONFIG = {
  logo: {
    path: '',
    alt: '',
    width: '',
    height: '',
  },
  showLogo: true,
  showSurveyButton: false,
  showUserProfile: true,
  showManageDriversTab: true,
  showChallengesTab: true,
  allowedRoutes: [
    'home',
    'safety-events',
    'trips',
    'live-view',
    'coaching',
    'video-requests',
    'drivers',
    'challenges',
    'reports',
    'assets',
    'user-management',
    'configurations',
  ],
  authRoutes: ['callback', 'tsplogin', 'admin-login', 'login', 'unauthorized-error', 'custom-login'],
  wildcardRoute: 'callback',
  defaultMapCoordinates: {
    lat: 40.25,
    lng: -74.5,
  },
  externalEventsLabel: 'Panic Button',
  showFeatureAnnouncement: true,
  showLogoutButton: true,
  defaultStorage: DefaultStorageType.LocalStorage,
  devicePrimaryKey: DevicePrimaryKey.DeviceId,
  showLandingPage: false,
  showPartnerLogo: false,
  showSecurityButton: true,
  showHomePageAnnouncement: false,
  showFeedbackButton: false,
  showUserTypeEmail: true,
  showTheme: true,
  showHeader: true,
  showSideNav: true,
  isAssetCentric: false,
  showHelpLink: false,
  disableSuprsendNotification: false,
  allowedMobileRoutes: ['safety-events', 'live-view', 'video-requests', 'notifications-page'],
};
export const SSO_DEFAULT_CLIENT_CONFIG = {
  ...DEFAULT_CLIENT_CONFIG,
  allowedRoutes: allowedRoutes.filter((r) => !ssoBlockedRoutes.includes(r)),
};

export const LOCONAV_RESELLER_DEFAULT_CLIENT_CONFIG = {
  ...DEFAULT_CLIENT_CONFIG,
  showChallengesTab: false,
  allowedRoutes: [
    'home',
    'safety-events',
    'trips',
    'live-view',
    'coaching',
    'video-requests',
    'drivers',
    'assets',
    'user-management',
    'configurations',
    'notification-setting',
  ],
};

export const GEOTAB_RESELLER_DEFAULT_CLIENT_CONFIG: any = {
  ...(DEFAULT_CLIENT_CONFIG as any),
  authRoutes: ['geotab-login', 'tsplogin'],
  wildcardRoute: 'geotab-login',
  ssoLocalStorageKeys: {
    credentials: 'geotab.credentials',
    server: 'geotab.server',
  },
  showUserProfile: true,
  showSurveyButton: true,
  showCopyrightText: true,
  showPrivacyPolicyLink: true,
  showLogoutButton: false,
  showSecurityButton: false,
  showFeatureAnnouncement: false,
  defaultStorage: DefaultStorageType.SessionStorage,
  showTheme: false,
  showHeader: false,
  showSideNav: false,
  disableSentry: true,
} as ClientConfig;

export enum Reseller {
  LM = 'lmpresales',
  Kore = 'kore',
  FleetLocate = 'fleetlocate',
  Solera = 'solera',
  Lightmetrics = 'lightmetrics',
  Satrack = 'satrack',
}
